/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { SolanaNFTSelector, SolanaNFTTypes } from 'store'
import {
  getSolanaNFtCollections,
  updateMagicEdenSlug,
  deleteMagicEdenSlug,
  addNewNFTProject,
} from 'services'
import { SolanaNFTCollectionFormModal, SolanaNFTCollectionList } from 'features'

import MainLayout from 'components/layouts/main'
import ArchiveDialog from 'components/commons/dialog/archive'
import { notifySuccess, notifyError } from 'components/commons/toast'

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'
import Button from 'components/commons/button'

const AddNewNFTPage = () => {
  const [openSeaSlug, setOpenSeaSlug] = useState('')
  const [selectedChain, setChain] = useState('solana')

  useEffect(() => {
    return () => setOpenSeaSlug('')
  }, [])

  const changeText = (e: any) => {
    setOpenSeaSlug(e.target.value)
    document
      .getElementById('openSeaLink')
      ?.setAttribute('href', 'https://opensea.io/collection/' + e.target.value)
  }

  const changeChain = (e: any) => {
    setChain(e.currentTarget.value)
  }

  const addProject = async () => {
    console.log('SLUG: ', openSeaSlug)
    console.log('CHAIN: ', selectedChain)
    await addNewNFTProject(openSeaSlug, selectedChain)

    setTimeout(() => {
      notifySuccess('NFT Project Added. Check top collections')
    }, 2000)
  }

  // NOTE: This is temporary and needs to be changed before working on prod
  // https://us-central1-nftfolio-dev.cloudfunctions.net/addNewCollection?slug=thediamondhands&chain=ethereum
  const addProjectTemp = () => {
    const newCollectionLink =
      'https://us-central1-nftfolio-dev.cloudfunctions.net/addNewCollection?slug=' +
      openSeaSlug +
      '&chain=' +
      selectedChain
    window.open(newCollectionLink, '_blank')
  }

  return (
    <React.Fragment>
      <MainLayout>
        <div className='justify-center items-center flex '>
          <div className='relative w-auto my-6 mx-auto max-w-3xl'>
            <div className='border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='relative px-8 pt-8 flex-auto space-y-6 md:mr-10 lg:mr-10'>
                <h1 className='text-black font-semibold' style={{ fontSize: 18 }}>
                  Add New NFT Project
                </h1>
                <div className='flex flex-row items-center space-x-2'>
                  <p>OpenSea Slug:</p>
                  <input
                    className='border-2 rounded-lg p-2'
                    value={openSeaSlug}
                    onChange={changeText}
                    required={true}
                  />
                </div>
                <div className='flex flex-row items-center space-x-2'>
                  <p style={{ marginRight: 16 }}>Chain:</p>
                  <label style={{ marginRight: 16 }}>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='chain'
                      value='ethereum'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeChain}
                    />
                    Ethereum
                  </label>
                  <label>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='chain'
                      value='solana'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeChain}
                    />
                    Solana
                  </label>
                </div>
                <p style={{ color: '#03a9f4', fontWeight: '500' }}>
                  Preview:{' '}
                  <a id='openSeaLink' target='_blank' style={{ textDecoration: 'underline' }}>
                    https://opensea.io/collection/{openSeaSlug}
                  </a>
                </p>
              </div>
              <Button
                onClick={() => addProjectTemp()}
                className='bg-blue-500 text-white font-semibold'
                style={{ marginTop: 24 }}
              >
                Add New NFT Project
              </Button>
            </div>
          </div>
        </div>

        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default AddNewNFTPage
